// Current time, re-rendering every `ms` - for reservation countdowns.
import { useEffect, useState } from 'react';

export default function useNow(ms = 1000) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}
